import React from 'react';
import classNames from 'classnames';

import css from './NotificationBadge.module.css';

// Counts above this render as "99+".
const MAX_COUNT = 99;

/**
 * Small badge/dot with number inside.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {number} props.count the number of notifications
 * @param {boolean?} props.isNeutral neutral colours for counts that do not mean "action required" (D33)
 * @returns {JSX.Element} badge component that shows how many notifications should be shown.
 */
const NotificationBadge = props => {
  const { className, rootClassName, count, isNeutral = false } = props;
  const classes = classNames(rootClassName || css.root, { [css.neutral]: isNeutral }, className);

  return <span className={classes}>{count > MAX_COUNT ? `${MAX_COUNT}+` : count}</span>;
};

export default NotificationBadge;
